// @flow
import { handleResponseOld, makeGet, makePost } from './helpers';

type GetResellerTypeParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
};

type PostResellerTypeParams = {
    authToken: string,
    bidderId: number,
    deployment: string,
    resellerType: number,
};

export default {
    getResellerType: ({ authToken, bidderId, deployment }: GetResellerTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({
                apiPath: `reseller/${bidderId}`,
                authToken,
                deployment,
                path: '<USER-API>',
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    postResellerType: ({ authToken, bidderId, deployment, resellerType }: PostResellerTypeParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({
                apiPath: `reseller/${bidderId}`,
                authToken,
                deployment,
                path: '<USER-API>',
            });
            request.send({ resellerType: resellerType });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
